module.exports = __webpack_public_path__ + "img/apple-touch-icon-180x180.4b5ee4a9.png";